function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'bleu': 'rgb(11, 61, 159)','noir': 'rgb(17, 17, 17)','denim': 'rgb(50, 78, 121)','rouge': 'rgb(225, 27, 27)','charbon': 'rgb(101, 101, 112)','charcoal': 'rgb(101, 101, 112)','marine': 'rgb(30, 30, 116)','acier': 'rgb(143, 143, 143)','steel': 'rgb(143, 143, 143)','khaki': 'rgb(86, 99, 82)','militaire': 'rgb(48, 62, 45)','military': 'rgb(48, 62, 45)','argente': 'rgb(196, 202, 207)','beige': 'rgb(159, 129, 16)','encre-noir': 'rgb(17, 17, 17)','black-ink': 'rgb(17, 17, 17)','marine-fonce': 'rgb(18, 55, 99)','dark-navy': 'rgb(18, 55, 99)','dark-charcoal': 'rgb(101, 101, 112)','charbon-fonce': 'rgb(101, 101, 112)','sable': 'rgb(159, 129, 16)','sand': 'rgb(159, 129, 16)','olive': 'rgb(67, 79, 61)','bleu-fonce': 'rgb(22, 49, 76)','dark-blue': 'rgb(22, 49, 76)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
